// extracted by mini-css-extract-plugin
export default {"btnDelete":"AppNav_btnDelete__2OKYZ","iconDelete":"AppNav_iconDelete__TrZGj","appnav":"AppNav_appnav__WFW76","welcomeName":"AppNav_welcomeName__y5rYT"};